<div class="w-full min-w-32 bg-white rounded-lg  relative">
  <label class="block w-full mx-1 text-sm font-medium text-gray-700" [class]="placeholder != '' ? 'pb-2' : ''"
    *ngIf="labelKey && displayLabel">
    {{ placeholder }}
  </label>

  <div class="relative">
    <input [(ngModel)]="searchQuery" (input)="filterItems();passInputChange()" (focus)="activateDropdown()"
      placeholder="{{ placeholder != '' ? placeholder : '- sélectionner -' }}"
      class="peer  w-full rounded-lg bg-white border border-gray-200 py-2 px-4 font-thin outline-none drop-shadow-sm transition-all duration-200 ease-in-out focus:bg-white focus:shadow-lg focus:shadow-blue-400" />

    <!-- Overlay -->
    <div *ngIf="toggleDropdown" (click)="deactivateDropdown()" class="fixed top-0 left-0 w-screen h-screen opacity-0">
    </div>

    <!-- Filtered List -->
    <ul *ngIf="filteredItems.length && toggleDropdown"
      class="absolute z-20 w-full bg-white border border-gray-200 rounded-lg shadow-lg mt-1 max-h-64 overflow-auto">
      <li *ngFor="let item of filteredItems" (click)="selectItem(item)"
        [class]="selectedItem && item[labelKey] === selectedItem[labelKey] ? 'font-bold' : ''"
        class="px-4 py-2 cursor-pointer hover:bg-blue-100">
        {{ item[labelKey] }}
      </li>
    </ul>
  </div>
</div>